import cn from 'clsx'
import * as React from 'react'
import { connect } from 'react-redux'
import type { Campaign, CampaignSection } from 'types/content-editor'
import type { State } from 'types/redux'
import { updateCampaignEditorSection } from '@disco/state-management/actions/campaign-editor-actions'
import {
  createCampaignFooter,
  updateCampaignFooter,
} from '@disco/state-management/actions/campaign-footer-actions'
import {
  getCampaignEditedSection,
  getCampaignEditorState,
} from '@disco/state-management/selectors/campaigns'
import SectionSettings from './section-settings'
import styles from './index.module.css'

const mapStateToProps = (state: State) => {
  return {
    campaign: getCampaignEditorState(state),
    ...getCampaignEditedSection(state),
  }
}

type Props = {
  campaign: Campaign
  section?: CampaignSection
  sectionIndex?: number
  updateCampaignEditorSection: typeof updateCampaignEditorSection
  updateCampaignFooter: typeof updateCampaignFooter
  createCampaignFooter: typeof createCampaignFooter
}

const ContentEditorBlockSettings = ({
  campaign,
  section,
  sectionIndex,
  updateCampaignEditorSection,
  updateCampaignFooter,
  createCampaignFooter,
}: Props) => {
  const className = cn(styles.contentEditorSidebarBlockSettings, {
    [styles.contentEditorSidebarBlockSettingsVisible]: !!section,
  })
  return (
    <div className={className}>
      {section && typeof sectionIndex === 'number' && sectionIndex >= 0 && (
        <SectionSettings
          campaign={campaign}
          section={section}
          sectionIndex={sectionIndex}
          updateSection={updateCampaignEditorSection}
          updateCampaignFooter={updateCampaignFooter}
          createCampaignFooter={createCampaignFooter}
        />
      )}
    </div>
  )
}

export default connect(mapStateToProps, {
  updateCampaignEditorSection,
  updateCampaignFooter,
  createCampaignFooter,
})(ContentEditorBlockSettings) as any
